import { identityServiceApi } from '../../../../infra/identityApi.service';
import { ADMINISTRATION_API } from '../../../../common/constants/api';

const ALL_KEYS = [
    'UserPermissions', 'PartUsers', 'MechanicUsers',
    'SalesUsers', 'SalesMac', 'SalesDon', 'SalesBrad',
    'SalesBrist', 'SalesMiltonKeynes', 'SalesCrawley',
    'drivers', 'compliance', 'complaintHandlers',
    'salesManagers', 'workshopMac', 'workshopDon',
    'workshopBrad', 'workshopBrist', 'workshopMiltonKeynes',
    'workshopCrawley', 'trade', 'AllUsers'
];

export const clearUsersCacheRequest = async (keys = ALL_KEYS) => {
    try {
        const res = await identityServiceApi({
            method: 'post',
            url: ADMINISTRATION_API.USER_MANAGEMENT.USERS_CACHE,
            data: {
                keys,
            },
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (error) {
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_create/requests/clear_users_cache.js